import gsap from 'gsap';

class Testimonials {
	constructor() {
		let cache = {};
		let currentIndex = 0;
		let totalSlides = 0;
		let isAnimating = false;
		let perView = 2;

		let initFunc = () => {
			initCache();
			if (!cache.track || cache.cards.length === 0) return;
			totalSlides = Math.ceil(cache.cards.length / perView);
			registerEvents();
		};

		let initCache = () => {
			cache.track = document.querySelector('.home-testimonials__track');
			cache.cards = document.querySelectorAll('.home-testimonials__card');
			cache.prev = document.querySelector('.home-testimonials__prev');
			cache.next = document.querySelector('.home-testimonials__next');
		};

		let registerEvents = () => {
			if (cache.prev) cache.prev.addEventListener('click', prev);
			if (cache.next) cache.next.addEventListener('click', next);
		};

		let getOffset = () => {
			if (!cache.cards[0]) return 0;
			const cardWidth = cache.cards[0].offsetWidth;
			const gap = 16;
			return currentIndex * perView * (cardWidth + gap);
		};

		let slideTo = () => {
			isAnimating = true;
			gsap.to(cache.track, {
				x: -getOffset(),
				duration: 0.6,
				ease: 'power3.inOut',
				onComplete: () => {
					isAnimating = false;
				}
			});
		};

		let next = () => {
			if (isAnimating) return;
			if (currentIndex < totalSlides - 1) {
				currentIndex++;
				slideTo();
			}
		};

		let prev = () => {
			if (isAnimating) return;
			if (currentIndex > 0) {
				currentIndex--;
				slideTo();
			}
		};

		initFunc();
	}
}

export { Testimonials };
